import { render, staticRenderFns } from "./add-wrist.vue?vue&type=template&id=767f3a23"
import script from "./add-wrist.vue?vue&type=script&lang=js"
export * from "./add-wrist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports